import React from "react";

/**
 * Sortable table header component
 */
const SortableHeader = ({ field, label, sortConfig, onSort }) => {
  const getSortIcon = () => {
    if (sortConfig.sortBy !== field) {
      return (
        <i
          className="fas fa-sort"
          style={{ fontSize: "10px", marginLeft: "4px" }}
        ></i>
      );
    }
    return sortConfig.sortDirection === "ASC" ? "▲" : "▼";
  };

  return (
    <th
      onClick={() => onSort(field)}
      style={{
        cursor: "pointer",
        userSelect: "none",
        position: "relative",
      }}
      className="sortable-header"
    >
      {label}
      <span style={{ marginLeft: "5px", fontSize: "0.8em", color: "#666" }}>
        {getSortIcon()}
      </span>
    </th>
  );
};

export default SortableHeader;
